import { Typography, TextField, MenuItem, IconButton } from "@mui/material";
import { useState } from "react";
import isEmail from "validator/lib/isEmail";
import { useDispatch, useSelector } from "react-redux";
import { login, setAvatar } from "../store/userSlice";
import LoginFunc from "../functions/LoginFunc";
import { Navigate, useLocation, useNavigate } from "react-router-dom";
import {
  ErrorOutlineSharp,
  Token,
  Visibility,
  VisibilityOff,
} from "@mui/icons-material";
import ButtonCo from "../modals/ButtonCo";
import BasicModal from "../modals/BasicModal";
import LoadingModal from "../modals/LoadingModal";
import classes from "./Form.module.css";
import { RootState } from "../store/store";
import { setActiveCountEvents } from "../store/dataSlice";
import FetchAllActiveCountEvents from "../functions/FetchAllActiveCountEvents";
import FetchAvatar from "../functions/FetchAvatar";

export default function Login() {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [isEmailValid, setisEmailValid] = useState(false);
  const [isEmailBlur, setisEmailBlur] = useState(false);
  const [isNameBlur, setisNameBlur] = useState(false);
  const [isPasswordBlur, setisPasswordBlur] = useState(false);
  const [isErrorModalOpen, setisErrorModalOpen] = useState(false);
  const [errorTitle, setErrorTitle] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [isLoadingModalOpen, setisLoadingModalOpen] = useState(false);
  const [showPassword, setshowPassword] = useState(false);
  const location = useLocation();
  const [inputs, setInputs] = useState({
    email: "",
    password: "",
  });
  const chUserFromRedux = useSelector((state: RootState) => {
    if (state.user.chUSER) {
      return state.user.chUSER;
    }
    return null;
  });

  if (chUserFromRedux != null) {
    return <Navigate to="/" state={{ from: location }} replace />;
  }

  const handleEmailChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    event.preventDefault();
    if (isEmail(event.target.value)) {
      setisEmailValid(true);
    } else {
      setisEmailValid(false);
    }

    setInputs((prevState) => ({
      ...prevState,
      [event.target.name]: event.target.value,
    }));
  };

  const errorHnadler2 = () => {
    setisErrorModalOpen(true);
  };
  const newOnClickHandle = (event: React.MouseEvent<HTMLButtonElement>) => {
    event.preventDefault();

    let dataUser;

    if (isEmailValid) {
      setisLoadingModalOpen(true);
      LoginFunc(inputs).then((res) => {
        setisLoadingModalOpen(false);
        if (res != "Error" && res != "gotError") {
          dataUser = JSON.parse(res);
          dispatch(login(dataUser));

          FetchAvatar(dataUser.chuser.avatar, dataUser.tokenString!).then(
            async (res) => {
              if (res != null) {
                const imageUrl = URL.createObjectURL(res);
                dispatch(setAvatar(imageUrl));
              }
            }
          );

          FetchAllActiveCountEvents(dataUser.tokenString).then((res2) => {
            if (res2 != "Error") {
              dispatch(setActiveCountEvents(JSON.parse(res2)));
            }
            if (res2 == "Error") {
            }
          });

          setInputs({
            email: "",
            password: "",
          });

          navigate("/SelectCountEvent");
        }

        if (res == "Error") {
          setErrorTitle("Incorrect password or username");
          setErrorMessage(
            "Please check your username and password and try again"
          );
          setisErrorModalOpen(true);
        }

        if (res == "gotError" || res.includes("Error")) {
          setErrorTitle("Server issues");
          setErrorMessage("Please try again in few minutes");
          setisErrorModalOpen(true);
        }
      });
    }
  };

  const handleMouseDownPassword = (
    event: React.MouseEvent<HTMLButtonElement>
  ) => {
    setshowPassword(false);
  };

  const handlePasswordChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    event.preventDefault();
    setInputs((prevState) => ({
      ...prevState,
      [event.target.name]: event.target.value,
    }));
  };

  const valid = isEmailValid && inputs.password.length > 1;

  return (
    <div>
      <LoadingModal open={isLoadingModalOpen}></LoadingModal>
      <BasicModal
        open={isErrorModalOpen}
        onClose={() => setisErrorModalOpen(false)}
        onConfirm={() => setisErrorModalOpen(false)}
        title={errorTitle}
        message={errorMessage}
      />
      <div className={classes.formHeader}>Sign in</div>
      <form>
        <TextField
          error={isEmailBlur && isEmailValid === false}
          onBlur={() => setisEmailBlur(true)}
          value={inputs.email}
          name="email"
          placeholder=""
          helperText="(Required)"
          onChange={handleEmailChange}
          style={{ width: "400px", margin: "25px" }}
          label="User E-mail"
          variant="outlined"
        />
        <br />
        <TextField
          value={inputs.password}
          name="password"
          onBlur={() => setisPasswordBlur(true)}
          onChange={handlePasswordChange}
          style={{ width: "400px", margin: "25px" }}
          type={showPassword ? "text" : "password"}
          label="User Password"
          helperText="(Required)"
          variant="outlined"
          InputProps={{
            endAdornment: (
              <IconButton
                aria-label="toggle password visibility"
                onMouseDown={() => setshowPassword(true)}
                onMouseUp={() => setshowPassword(false)}
                onMouseLeave={() => setshowPassword(false)}
                edge="end"
              >
                {showPassword ? <VisibilityOff /> : <Visibility />}
              </IconButton>
            ),
          }}
        />
        <br />
        <br />
        <ButtonCo type="submit" onClick={newOnClickHandle} disabled={!valid}>
          Login
        </ButtonCo>
      </form>
    </div>
  );
}
